<div class="modal-header">
  <h2 class="modal-title fw-bold">Edit Registration</h2>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    <!-- Current Registration Info -->
    <div class="alert alert-info d-flex align-items-start mb-6">
      <i class="fa fa-info-circle fs-2x me-3 mt-1"></i>
      <div>
        <div class="fw-bold mb-2">Current Registration</div>
        <div class="mb-1">
          <strong>Rider:</strong>
          @if (registration.user) {
            {{ registration.user.first_name }} {{ registration.user.last_name }}
            @if (registration.user.email) {
              <span class="text-muted">({{ registration.user.email }})</span>
            }
          } @else {
            <span class="text-muted">N/A</span>
          }
        </div>
        <div>
          <strong>Horse:</strong>
          @if (registration.horse) {
            {{ registration.horse.name }}
            @if (registration.horse.breed) {
              <span class="text-muted">({{ registration.horse.breed }})</span>
            }
          } @else {
            <span class="text-muted">N/A</span>
          }
        </div>
      </div>
    </div>

    <!-- User Search Field -->
    <div class="mb-5">
      <label class="form-label required">Rider</label>
      <div class="position-relative">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="userSearchTerm"
            [ngModelOptions]="{standalone: true}"
            (input)="onUserSearch()"
            placeholder="Search by name or email..."
            [class.is-invalid]="userIdInvalid"
          />
          @if (selectedUser) {
            <button
              class="btn btn-outline-secondary"
              type="button"
              (click)="clearUserSearch()"
            >
              <i class="fa fa-times"></i>
            </button>
          }
        </div>
        @if (userIdInvalid) {
          <div class="text-danger fs-7 mt-1">Rider is required</div>
        }

        <!-- User Dropdown -->
        @if (filteredUsers.length > 0 && userSearchTerm && !selectedUser) {
          <div class="user-dropdown position-absolute w-100 bg-white border rounded shadow-sm mt-1" style="z-index: 1000; max-height: 300px; overflow-y: auto;">
            @for (user of filteredUsers; track user.user_id) {
              <div
                class="user-item p-3 cursor-pointer hover-bg-light border-bottom"
                (click)="selectUser(user)"
              >
                <div class="fw-semibold">{{ user.first_name }} {{ user.last_name }}</div>
                @if (user.email) {
                  <div class="text-muted fs-7">{{ user.email }}</div>
                }
              </div>
            }
          </div>
        }

        <!-- Selected User Display -->
        @if (selectedUser) {
          <div class="mt-3 p-4 bg-light rounded">
            <div class="fw-bold mb-2">Selected Rider</div>
            <div class="row g-3">
              <div class="col-md-6">
                <div class="text-muted fs-7">Name</div>
                <div class="fw-semibold">{{ selectedUser.first_name }} {{ selectedUser.last_name }}</div>
              </div>
              @if (selectedUser.email) {
                <div class="col-md-6">
                  <div class="text-muted fs-7">Email</div>
                  <div class="fw-semibold">{{ selectedUser.email }}</div>
                </div>
              }
              <div class="col-md-6">
                <div class="text-muted fs-7">User ID</div>
                <div class="fw-semibold">{{ selectedUser.user_id }}</div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <!-- Horse Selector -->
    <div class="mb-5">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <label class="form-label required mb-0">Horse</label>
        <button
          type="button"
          class="btn btn-sm btn-light-primary"
          (click)="openAddHorseModal()"
          [disabled]="!selectedUser"
        >
          <i class="fa fa-plus me-1"></i>
          Add New Horse
        </button>
      </div>
      @if (loadingHorses) {
        <div class="d-flex align-items-center">
          <div class="spinner-border spinner-border-sm me-2" role="status"></div>
          <span class="text-muted">Loading horses...</span>
        </div>
      } @else {
        @if (availableHorses.length > 0) {
          <app-selectorini
            [options]="availableHorses"
            [displayKey]="'name'"
            [valueKey]="'horse_id'"
            [placeholder]="'Select a horse from all horses in the system'"
            [value]="form.get('horse_id')?.value"
            (valueChange)="onHorseChanged($event)"
            [searchable]="true"
          />
          @if (horseIdInvalid) {
            <div class="text-danger fs-7 mt-1">Horse is required</div>
          }
          <div class="text-muted fs-7 mt-1">
            Showing all horses in the system ({{ availableHorses.length }} total)
          </div>
          @if (selectedHorse) {
            <div class="mt-3 p-4 bg-light rounded">
              <div class="fw-bold mb-2">Selected Horse Details</div>
              <div class="row g-3">
                <div class="col-md-6">
                  <div class="text-muted fs-7">Name</div>
                  <div class="fw-semibold">{{ selectedHorse.name }}</div>
                </div>
                @if (selectedHorse.breed) {
                  <div class="col-md-6">
                    <div class="text-muted fs-7">Breed</div>
                    <div class="fw-semibold">{{ selectedHorse.breed }}</div>
                  </div>
                }
                @if (selectedHorse.color) {
                  <div class="col-md-6">
                    <div class="text-muted fs-7">Color</div>
                    <div class="fw-semibold">{{ selectedHorse.color }}</div>
                  </div>
                }
                @if (selectedHorse.gender) {
                  <div class="col-md-6">
                    <div class="text-muted fs-7">Gender</div>
                    <div class="fw-semibold">{{ selectedHorse.gender }}</div>
                  </div>
                }
              </div>
            </div>
          }
        } @else {
          <div class="alert alert-warning d-flex align-items-center">
            <i class="fa fa-exclamation-triangle me-2"></i>
            <div>
              @if (form.get('user_id')?.value) {
                No horses found for this user. Please ensure the user has registered horses.
              } @else {
                Please enter a User ID first to load available horses.
              }
            </div>
          </div>
        }
      }
    </div>
  </form>
</div>

<div class="modal-footer">
  <app-button
    [variant]="'outline'"
    [label]="'Cancel'"
    (clicked)="close()"
    [disabled]="saving"
  />
  <app-button
    [variant]="'primary'"
    [label]="saving ? 'Saving...' : 'Save Changes'"
    [iconClass]="saving ? 'fa fa-spinner fa-spin' : 'fa fa-save'"
    (clicked)="save()"
    [disabled]="saving || form.invalid"
  />
</div>
